module.exports = __webpack_public_path__ + "static/media/icone_oeuvreprotestante_old.abf00831.svg";